/**
 * @generated SignedSource<<fcb95378cec2b9dfcf0941f176ca70ed>>
 * @relayHash e0af0f5b07408bfdaef76130333caa06
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5f42d0ffc0e73fdbfeead19d283ede47ff0d88924c7994d70e04853ef0ef1d7e

import type { ConcreteRequest, Query } from 'relay-runtime';
export type knowledgeHubBrowseAllArticlesKBTypeCheckerQuery$variables = {
  cloudId: string;
  container: string;
};
export type knowledgeHubBrowseAllArticlesKBTypeCheckerQuery$data = {
  readonly knowledgeBase: {
    readonly knowledgeBase: {
      readonly __typename: "KnowledgeBaseSources";
      readonly edge: ReadonlyArray<{
        readonly node: {
          readonly sourceType: string;
        };
      } | null | undefined>;
    } | {
      readonly __typename: "QueryError";
      readonly message: string | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
  } | null | undefined;
  readonly knowledgeBase_getLinkedSourceTypes: {
    readonly linkedSourceTypes?: ReadonlyArray<string | null | undefined> | null | undefined;
  } | null | undefined;
};
export type knowledgeHubBrowseAllArticlesKBTypeCheckerQuery = {
  response: knowledgeHubBrowseAllArticlesKBTypeCheckerQuery$data;
  variables: knowledgeHubBrowseAllArticlesKBTypeCheckerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "container"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "container",
    "variableName": "container"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "sourceType"
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ],
  "type": "QueryError"
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "linkedSourceTypes"
    }
  ],
  "type": "KnowledgeBaseLinkedSourceTypes"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "knowledgeHubBrowseAllArticlesKBTypeCheckerQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "KnowledgeBaseQueryApi",
        "kind": "LinkedField",
        "name": "knowledgeBase",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "knowledgeBase",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "KnowledgeBaseSourceEdge",
                      "kind": "LinkedField",
                      "name": "edge",
                      "plural": true,
                      "selections": [
                        {
                          "concreteType": "KnowledgeBaseSource",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "RequiredField",
                              "field": (v4/*: any*/),
                              "action": "THROW",
                              "path": "knowledgeBase.knowledgeBase.edge.node.sourceType"
                            }
                          ]
                        }
                      ]
                    },
                    "action": "THROW",
                    "path": "knowledgeBase.knowledgeBase.edge"
                  }
                ],
                "type": "KnowledgeBaseSources"
              },
              (v5/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v2/*: any*/),
        "kind": "LinkedField",
        "name": "knowledgeBase_getLinkedSourceTypes",
        "plural": false,
        "selections": [
          (v6/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "knowledgeHubBrowseAllArticlesKBTypeCheckerQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "KnowledgeBaseQueryApi",
        "kind": "LinkedField",
        "name": "knowledgeBase",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "knowledgeBase",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "KnowledgeBaseSourceEdge",
                    "kind": "LinkedField",
                    "name": "edge",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "KnowledgeBaseSource",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "type": "KnowledgeBaseSources"
              },
              (v5/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v2/*: any*/),
        "kind": "LinkedField",
        "name": "knowledgeBase_getLinkedSourceTypes",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v6/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "5f42d0ffc0e73fdbfeead19d283ede47ff0d88924c7994d70e04853ef0ef1d7e",
    "metadata": {},
    "name": "knowledgeHubBrowseAllArticlesKBTypeCheckerQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a2fd150c884f4ec63528c5154dee11ab";

export default node;
